var map = {
	"./garlic.jpg": 142,
	"./maize.jpg": 143,
	"./potato.jpg": 144,
	"./rice.jpg": 145,
	"./tomato.jpg": 146,
	"./tractor.jpg": 148,
	"./wheat.jpg": 147
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 171;